export const projectKeys = {
  all: ["projects"] as const,
  list: (clientId?: string) => [...projectKeys.all, "list", clientId] as const,
  detail: (id: string) => [...projectKeys.all, "detail", id] as const,
};

export const epicKeys = {
  all: ["epics"] as const,
  list: (projectId: string) => [...epicKeys.all, "list", projectId] as const,
};

export const sprintKeys = {
  all: ["sprints"] as const,
  list: (projectId: string) => [...sprintKeys.all, "list", projectId] as const,
};

export const taskKeys = {
  all: ["tasks"] as const,
  list: (filters: Record<string, string | undefined>) => [...taskKeys.all, "list", filters] as const,
  detail: (id: string) => [...taskKeys.all, "detail", id] as const,
};

export const userKeys = {
  all: ["users"] as const,
  list: () => [...userKeys.all, "list"] as const,
};

export const timeEntryKeys = {
  all: ["timeEntries"] as const,
  list: (filters: Record<string, string | undefined>) => [...timeEntryKeys.all, "list", filters] as const,
};

export const clientKeys = {
  all: ["clients"] as const,
  list: () => [...clientKeys.all, "list"] as const,
  detail: (id: string) => [...clientKeys.all, "detail", id] as const,
};

export const reportKeys = {
  all: ["reports"] as const,
  byProject: (projectId: string, from: string, to: string) => [...reportKeys.all, "by-project", projectId, from, to] as const,
  byClient: (clientId: string, from: string, to: string) => [...reportKeys.all, "by-client", clientId, from, to] as const,
  byUser: (userId: string, from: string, to: string) => [...reportKeys.all, "by-user", userId, from, to] as const,
  timeline: (scope: string, scopeId: string, from: string, to: string, granularity: string) =>
    [...reportKeys.all, "timeline", scope, scopeId, from, to, granularity] as const,
  velocity: (projectId: string) => [...reportKeys.all, "velocity", projectId] as const,
};

export const ticketKeys = {
  all: ["tickets"] as const,
  list: (filters: Record<string, string | undefined>) => [...ticketKeys.all, "list", filters] as const,
  detail: (id: string) => [...ticketKeys.all, "detail", id] as const,
};
